/* eslint-disable */
const decryptData = (msg, name) => {
  const obj = {};

  if (name == "courseinfo") {
    //1. Remove "#$newLine"
    let str = msg.text.replace("#$newLine$#", "");

    // 1. Split with rest all "#$newLine"
    let newline = str.split("#$newLine$#");
    console.log(newline);
    var prev = "";
    for (var j = 0; j < newline.length; j++) {
      newline[j].trim();
      let sp = newline[j].split("->");
      console.log("len :" + sp.length);
      if (sp.length == 1) {
        obj[prev] = obj[prev] + newline[j];
      } else {
        sp[0].trim();
        sp[1].trim();
        obj[sp[0]] = sp[1];
        prev = sp[0];
      }
    }
  }
  console.log(obj);
  /* Price */
  if (
    msg.responseCard &&
    msg.responseCard.genericAttachments &&
    msg.responseCard.genericAttachments.length > 0
  ) {
    if (msg.responseCard.genericAttachments[0].subTitle) {
      /* */
      let subTitle = msg.responseCard.genericAttachments[0].subTitle.slice("");

      // Check for large bracket
      let infoPatt = /\[.*?\]/g;
      let testExtraInfo = infoPatt.test(subTitle);

      if (testExtraInfo) {
        let extraInfo = subTitle.match(infoPatt);
        extraInfo.forEach(item => {
          // Remove pattern text from subTitle
          subTitle = subTitle.replace(item, "");
          item = item
            .replace(/\[/g, "")
            .replace(/\]/g, "")
            .trim();
          console.log(item);
          obj.taxIncluded = item === "Inclusive of all taxes";
        });
      }

      let splitDash = subTitle.split("|");
      if (splitDash.length > 0) {
        console.log(splitDash);
        splitDash.forEach(item => {
          //  let point = item.search(":");
          let splitColone = item.split(":");

          obj[splitColone[0].trim()] = splitColone[1].trim();
          // obj[item.slice(0, point)] = item.slice(point, item.length);
        });
        console.log(obj);
      }
    }
    console.log(obj);
    /* Title */
    if (msg.responseCard.genericAttachments[0].title) {
      let title = msg.responseCard.genericAttachments[0].title.slice("");
      let infoPatt = /\[.*?\]/g;
      if (infoPatt.test(title)) {
        title = title.replace(infoPatt, "");
      }
      obj.title = title.trim();
    }
    console.log(obj);
    if (
      msg.responseCard.genericAttachments[0].buttons &&
      msg.responseCard.genericAttachments[0].buttons.length > 0
    ) {
      obj.buttons = msg.responseCard.genericAttachments[0].buttons;
    }
    console.log(obj);
  }
  console.log(obj);
  return obj;
};

const filterData = txt => {
  return txt;
};

const faqData = message => {
  let msg = { ...message };
  var faqPatt = /\{\{.*?\}\}/g;
  if (faqPatt.test(msg.text)) {
    var findmsg = msg.text.search(/\{\{.*?\}\}/);
    msg.introMsg = msg.text.slice(0, findmsg).replace("#$newLine$#", "");

    let txt = msg.text.replaceAll('"', "&quot;");
    txt.match(faqPatt);
    txt = txt.match(faqPatt);
    txt = txt[0].slice(1, txt[0].length - 1);
    txt = txt.replaceAll(/\'/g, '"');
    msg.faqcontent = JSON.parse(txt);

    let pushMessage = {
      type: message.type,
      text: msg.introMsg,
      keywords: "faq-bot-answer",
      thumbnailURL: null,
      faqcontent: msg.faqcontent ? msg.faqcontent : null,
      intentName: msg.intentName,
      sessionAttributes: msg.sessionAttributes ? msg.sessionAttributes : null
    };
  }
  return msg;
};

export { decryptData, filterData, faqData };



// WEBPACK FOOTER //
// ./src/lib/decrypt.js